import { render, staticRenderFns } from "./reminderStatus.vue?vue&type=template&id=422792b9&"
import script from "./reminderStatus.vue?vue&type=script&lang=js&"
export * from "./reminderStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports